<template>
  <div class="container">
    <!-- 菜单导航 -->
    <Menu></Menu>
    <div class="main-wrapper-content playback-list">
      <div class="breadcrumb_box">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/personal' }">我的课程</el-breadcrumb-item>
          <el-breadcrumb-item>{{course.title}}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="course-head">
        <div class="background-box"></div>
        <div class="content-box">
          <img :src="course.thumb" alt="">
          <h1>{{course.title}}</h1>
        </div>
      </div>
      <div class="content_tab">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="直播列表" name="1">
          </el-tab-pane>
          <el-tab-pane label="预习列表" name="2">
          </el-tab-pane>
          <el-tab-pane label="知识拓展" name="3">
          </el-tab-pane>
        </el-tabs>
      </div>
      <div class="course-center">
        <div class="course-center_div" v-if="chapterListData != []&&item.classes_id" v-for="(item,index) in chapterListData" :key="index"
          @click="showCourse(index,item)">
          <div class="left">
            <h3>
              <span>{{ nowTime > item.end_times ?'已结束':nowTime>item.start_times?'进行中':'未开始' }}</span>
              第{{ index +1 }}节
              {{ item.title }}
            </h3>
            <p>直播：{{ item.start_time }}~{{ item.end_time }}</p>
          </div>
          <div class="right">
            <el-button v-if="item.video" round>查看回放</el-button>
            <el-button style="background:white;" v-if="nowTime > item.end_times&&!item.video" round>回放上传中</el-button>
          </div>
        </div>
        <div class="course-center_div" v-if="chapterListData != []&&item.course_id" v-for="(item,index) in chapterListData" :key="index"
          @click="showCourse(index,item)">
          <div class="left">
            <h3>第{{ index +1 }}节
              {{ item.title }}
            </h3>
          </div>
          <div class="right">
            <el-button v-if="item.video" round>录播播放</el-button>
          </div>
        </div>
      </div>
    </div>
    <!-- 底部链接 -->
    <Footer></Footer>
  </div>
</template>
<script>
  import Menu from '@/components/view/Menu'
  import Footer from '@/components/view/Footer'
  export default {
    name: 'classes',
    components: {
      Menu,
      Footer
    },
    data() {
      return {
        activeName: '2',
        course: {},
        activeLoad: 2,
        chapterListData: [],
        nowTime: '',
        classes_id:0
      }
    },
    created() {
      this.nowTime = Date.now()
      this.courseInfo()
      this.chapterList(2, this.$route.query.id)
    },
    methods: {

      handleClick(tab, event) {
        if (tab.index == 2) {
          this.chapterListData = this.course.chapter
        } else {
          this.chapterList(parseInt(tab.index) + 1, this.$route.query.id)
        }
      },

      // 课程详情
      courseInfo() {
        this.$axios({
          method: 'post', // 请求格式
          url: '/api/course/detail', // 请求路径
          headers: { // 设置请求头
            token: this.$cookieStore.getCookie('token'),
          },
          data: {
            "id": this.$route.query.id,
          }
        }).then(res => {
          this.course = res.data.data
        }).catch(err => {})
      },

      // 章节列表
      chapterList(type, id) {
        this.$axios({
          method: 'post', // 请求格式
          url: '/api/user/CourseDetail', // 请求路径
          headers: { // 设置请求头
            token: this.$cookieStore.getCookie('token'),
          },
          data: {
            "course_id": id,
            "type": type
          }
        }).then(res => {
          for (var i = 0; i < res.data.data.length; i++) {
            res.data.data[i]['start_times'] = Date.parse(res.data.data[i]['start_time'])
            res.data.data[i]['end_times'] = Date.parse(res.data.data[i]['end_time'])
          }
          this.chapterListData = res.data.data
          if(res.data.data){
             this.classes_id = res.data.data[0]['classes_id']
          }
        })
      },

      showCourse(index,item) {
        let tabIndex = 1
        // 知识扩展
        if(item.course_id){
          tabIndex = 2
          index = index+100
          item.classes_id = this.classes_id
        }
        if (item.video) {
          this.$router.push({
            path: "/CurriculumDetails",
            query: {
              id: item.classes_id,
              courseId:this.$route.query.id,
              video:item.video,
              index:index,
              tabIndex:tabIndex
            }
          })
        } else {
          if(this.nowTime < item.end_times){
            this.$router.push({
              path: "/ClassesLive",
              query: {
                id: item.id
              }
            })
          }
        }
      }
    }
  }
</script>
<style scoped lang="scss">
  /deep/ .el-tabs__nav-wrap::after {
    background: none;
  }

  /deep/ .el-tabs__item {
    font-weight: 600;
    color: #747c80;
    padding: 0;
    width: 85px;
    height: 25px;
    line-height: 25px;
    font-size: 16px;
    margin-right: 10px;
  }

  /deep/ .is-active {
    background: #fff;
    color: #FABE00 !important;
    border-radius: 8px;
  }

  /deep/ .el-tabs__active-bar {
    background: none;
  }
</style>
<style scoped>
  .content_tab {
    background: #F5F8F8;
    padding-top: 15px;
    padding-left: 14px;
    border-radius: 10px;
    margin-top: 20px;
  }

  .playback-list {
    padding: 0px;
    margin: 0px;
    width: 780px;
    margin: 0 auto;
    min-height: 750px;
  }

  .content_top {
    padding: 20px 0;
  }

  .course-center {
    margin: 20px 0;
  }

  .course-center_div {
    height: 60px;
    width: 100%;
    padding: 18px 0;
    border-bottom: 1px solid #e6e6e6;
  }

  .course-center_div .left {
    float: left;
    text-align:left;
  }

  .course-center_div .right {
    float: right;
    padding-top: 10px;
    padding-right: 20px;
  }

  /deep/ .course-center_div .right button {
    border: none;
    background: #FABE01;
  }

  .course-center_div h3 {
    font-size: 18px;
    margin-left: 5px;
    font-weight: normal;
    color: #212529;
  }

  .course-center_div span {
    margin-right: 10px;
    color: white;
    background-color: #465156;
    padding: 2px 5px;
    border-radius: 3px;
    font-size: 14px;
  }

  .course-center_div p {
    font-size: 14px;
    margin-top: 10px;
    margin-left: 5px;
  }

  .course-head {
    position: relative;
    display: flex;
    height: 190px;
    /* margin: 20px 0; */
    padding: 20px;
    background-size: cover;
    background-color: #eee;
    overflow: hidden;
    border-radius: 6px;
    box-sizing: border-box;
  }

  .background-box {
    background: url(http://image.dapengjiaoyu.com/2020/12/FS2m1YQt.jpg);
    position: absolute;
    z-index: 1;
    top: 0;
    left: 0;
    width: 780px;
    height: 190px;
    opacity: .6;
    filter: blur(50px);
  }

  .content-box {
    position: absolute;
    z-index: 2;
    top: 0;
    left: 0;
    width: 780px;
    display: flex;
    height: 190px;
    padding: 20px;

  }

  .content-box>img {
    width: 225px;
    height: 150px;
    border-radius: 6px;
    margin-right: 16px;

  }

  .content-box>h1 {
    font-size: 24px;
    font-family: PingFangSC-Semibold, PingFang SC, Helvetica, STHeiti, Microsoft YaHei, "sans-serif";
    font-weight: 600;
    color: #18252c;
    line-height: 33px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 600px;
    margin-top: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/components/CourseClasses.vue